module.exports = __webpack_public_path__ + "static/media/6.e03db6a2.gif";